import {
    ACTION_USER_AUTHENTICATE,
    ACTION_USER_FETCH,
    ACTION_USER_UPDATE_PASSWORD,
    ACTION_USER_LOGOUT,
    ACTION_USER_UPDATE,
    ACTION_USER_SAVE,
    ACTION_SWITCH_USER_LOGIN,
    ACTION_SWITCH_USER_EXIT,
    ACTION_USER_SUBSCRIBE_PRO,
    ACTION_USER_RENEW_PLAN,
    ACTION_FETCH_ACCOUNT_MERGE_REQUESTS,
    CREATE_INVITATION,
    CREATE_JOURNAL,
    CREATE_ENTRY_MEDIA,
    FACEBOOK_LOGIN,
    GOOGLE_LOGIN
} from 'redux/actions/actionTypes';
import { logout } from 'redux/actions/user';
import { SUCCESS_SUFFIX, ERROR_SUFFIX, ERROR_MESSAGES } from 'common/constant';
import { actions } from 'react-redux-form';
import { updateUI } from 'redux/actions/ui';

const initState = {
    isAuthorized: false
};

const UserReducer = (state = { ...initState }, action) => {
    switch (action.type) {
        case ACTION_USER_AUTHENTICATE + SUCCESS_SUFFIX: {
            return {
                ...state,
                isAuthorized: true,
                ...action.payload.data
            };
        }
        case GOOGLE_LOGIN + SUCCESS_SUFFIX:
        case FACEBOOK_LOGIN + SUCCESS_SUFFIX: {
            const { api_v1_key, key, username } = action.payload.data;

            return Object.assign({}, state, {
                isAuthorized: true,
                api_key: api_v1_key,
                api_v2_key: key,
                username
            });
        }
        case ACTION_USER_AUTHENTICATE + ERROR_SUFFIX: {
            const newState = { ...state };
            action.asyncDispatch(
                actions.setValidity('login.email_username', {
                    isCorrect: false
                })
            );
            action.asyncDispatch(
                actions.setValidity('login.password', { isCorrect: false })
            );

            return {
                ...newState,
                isAuthorized: false
            };
        }
        case ACTION_USER_FETCH + SUCCESS_SUFFIX:
        case ACTION_USER_UPDATE_PASSWORD + SUCCESS_SUFFIX: {
            return {
                ...state,
                isAuthorized: true,
                ...action.payload.data
            };
        }
        case ACTION_USER_LOGOUT: {
            return {
                isAuthorized: false,
                ...initState
            };
        }
        case ACTION_USER_FETCH + ERROR_SUFFIX: {
            // Don't logout SU users on v1 API failures - they use v2 API
            if (!state.is_su) {
                action.asyncDispatch(logout());
            } else {
                console.error('Ignoring v1 API fetch failure for SU user');
            }
            return {
                ...state
            };
        }
        case ACTION_USER_UPDATE + SUCCESS_SUFFIX:
        case ACTION_USER_SUBSCRIBE_PRO + SUCCESS_SUFFIX:
        case ACTION_USER_RENEW_PLAN + SUCCESS_SUFFIX: {
            return {
                ...state,
                ...action.payload.data
            };
        }

        case ACTION_USER_SAVE: {
            const newState = {
                ...state,
                isAuthorized: true,
                ...action.payload
            };
            return newState;
        }

        case ACTION_SWITCH_USER_LOGIN + SUCCESS_SUFFIX: {
            return {
                ...state,
                isAuthorized: true,
                ...action.payload.data.user,
                api_key: action.payload.data.api_key,
                api_v2_key: action.payload.data.api_v2_key,
                is_su: action.payload.data.is_su,
                su_admin_email: action.payload.data.su_admin_email,
                su_audit_log_id: action.payload.data.su_audit_log_id,
                su_session_expires_at: action.payload.data.su_session_expires_at
            };
        }

        case ACTION_SWITCH_USER_EXIT + SUCCESS_SUFFIX: {
            return {
                isAuthorized: false,
                ...initState
            };
        }

        case CREATE_INVITATION + ERROR_SUFFIX:
        case CREATE_JOURNAL + ERROR_SUFFIX:
        case CREATE_ENTRY_MEDIA + ERROR_SUFFIX: {
            if (state.is_free === true) {
                action.asyncDispatch(
                    updateUI({
                        errors: {
                            type: ERROR_MESSAGES.FREE_ACCOUNT_PERMISSION_ERROR
                        }
                    })
                );
            }
            return state;
        }

        case ACTION_FETCH_ACCOUNT_MERGE_REQUESTS + SUCCESS_SUFFIX: {
            const mergeRequests =
                action.payload?.data?.objects ||
                action.payload?.data?.results ||
                action.payload?.data ||
                [];
            return {
                ...state,
                mergeRequests
            };
        }

        default: {
            return {
                ...state
            };
        }
    }
};
export default UserReducer;
